<div
  class="border-default bg-surface focus:border-accent-focus focus:ring-accent-focus duration-fast flex items-center overflow-hidden rounded-md border px-1 transition-colors *:min-w-0 focus:ring-2 focus:outline-none"
  [style.width.px]="tableCellWidth() || null"
  [style.min-height.px]="tableCellHeight() || null">
  <app-entity-auto-complete
    [entityType]="entityType()"
    [ownerEntityType]="ownerEntityType()"
    [id]="columnId()"
    [(value)]="entityValue"
    [isArray]="false"
    [formControl]="formControl" />
</div>
